<div class="mt-40">
  <div class="table-responsive prop-list column-view">
    <table>
      <tbody class="prop-body">
        <tr>
          <td>
            <div class="d-flex align-items-center gap-2 back-icon">
              <mat-icon class="mat-icon" (click)="back()"> arrow_back </mat-icon>
              <span class="comp-head">Comparables</span><br />
            </div>
            <div class="pro-tips">
              <i
                ><b>Pro Tips :</b> Remember you are adjusting the comp to the subject so it is inverse. Example: Comp
                has a pool subject doesn’t, it would be a negative adjustment to that comp.</i
              >
            </div>
          </td>
          <td *ngFor="let property of properties">
            <div class="row">
              <div class="col-12 text-center">
                <img
                  *ngIf="property.ListingId"
                  class="mx-auto report-image"
                  [src]="listingImageBaseUrlAlt + '?ListingId=' + property.ListingId + '&ImageName=1&height=180'"
                />
                <img
                  *ngIf="!property.ListingId"
                  class="mx-auto report-image"
                  [src]="listingImageBaseUrlAlt + '?ListingId=null&ImageName=1'"
                />

                <!-- Similarity Score -->
                <p *ngIf="property.SimilarityScore" class="similar-score">
                  {{ property.SimilarityScore | number: '1.0-0' }}%
                </p>
                <p (click)="openWeightDialog()" class="property-per" *ngIf="property.percentage">
                  {{ property.percentage }} / 100
                </p>

                <!-- Status -->
                <p
                  [ngClass]="{
                    'sold-status': property.StandardStatus === 'Sold',
                    'active-status':
                      property.StandardStatus === 'Active' ||
                      property.StandardStatus === 'Active UC' ||
                      property.StandardStatus === 'Active Under Contract' ||
                      property.StandardStatus === 'Pending',
                    'cancel-status': property.StandardStatus === 'Cancel/Withdrawn',
                    'expired-status': property?.StandardStatus === 'Expired'
                  }"
                >
                  {{ property.StandardStatus }}
                </p>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td class="address-lbl">Address</td>
          <td *ngFor="let property of properties" class="comp-address address prop-itm ng-star-inserted">
            <div (click)="openPropertyDetails(property)">
              {{ property.UnparsedAddress }} <br /><small>
                {{ property.City }} , {{ property.StateOrProvince }} {{ property.PostalCode }}
              </small>
            </div>
          </td>
        </tr>

        <tr class="adjusted-price">
          <td class="adjusted-lbl">Adjusted Price</td>
          <td *ngFor="let property of properties">${{ property.adjustedPrice | number }}</td>
        </tr>

        <tr class="price-adjustment">
          <td class="price-lbl">Price + Adjustment</td>
          <td *ngFor="let property of properties; let i = index">
            <div class="d-flex justify-content-between align-items-center" *ngIf="i != 0">
              <span>${{ property.listOrClosePrice | number }}</span>
              <span class="text-success" *ngIf="property.adjustmentSum >= 0"
                >+${{ property.adjustmentSum | number }}</span
              >
              <span class="text-danger" *ngIf="property.adjustmentSum < 0"
                >-${{ getAbs(property.adjustmentSum) | number }}</span
              >
            </div>
          </td>
        </tr>

        <tr *ngFor="let attr of attributes; let i = index">
          <td class="d-flex align-items-center justify-content-between gap-2">
            <span>{{ attr.label }}</span>
            <div class="d-flex align-items-center">
              <input
                *ngIf="allowedKeysForInput.includes(attr.key)"
                [(ngModel)]="attr[attr.key + 'Price']"
                type="number"
                class="form-control"
                (ngModelChange)="applyAdjustment(attr)"
                style="width: 90px"
                (wheel)="onWheel($event)"
                [ngStyle]="{
                  color: attr[attr.key + 'Price'] > 0 ? 'green' : attr[attr.key + 'Price'] < 0 ? 'red' : 'black'
                }"
              />
            </div>
          </td>

          <td *ngFor="let property of properties; let i = index">
            <div class="d-flex align-items-center justify-content-between">
              <span>{{
                isNumber(property[attr.key], attr.key) ? (property[attr.key] | number) : property[attr.key]
              }}</span>
              <div class="d-flex align-items-center">
                <input
                  *ngIf="allowedKeysForInput.includes(attr.key) && i != 0"
                  type="checkbox"
                  [(ngModel)]="property[attr.key + 'Checked']"
                  class="form-check-input me-2"
                  (change)="applyAdjustment(attr)"
                />
                <input
                  *ngIf="i != 0"
                  type="number"
                  class="form-control"
                  [(ngModel)]="property[attr.key + 'Price']"
                  [disabled]="allowedKeysForInput.includes(attr.key) && !property[attr.key + 'Checked']"
                  (ngModelChange)="applyAdjustment(attr)"
                  style="width: 100px"
                  (wheel)="onWheel($event)"
                  [ngStyle]="{
                    color:
                      property[attr.key + 'Price'] > 0 ? 'green' : property[attr.key + 'Price'] < 0 ? 'red' : 'black'
                  }"
                />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="sticky-footer">
    <div class="row mx-0 w-100">
      <div class="col-md-12 col-sm-12 col-12 pr-2">
        <div class="d-md-flex">
          <div class="">
            <strong>Model Adjusted Value</strong>
            <!-- <mat-icon class="info-icon pl-1"> info </mat-icon> -->
            :
            <b> ${{ properties[0]?.adjustedPrice | number }}</b>
          </div>
          <button mat-flat-button color="primary" class="primary float-right ml-auto" (click)="saveAdjustments()">
            Update Value
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="confirm-dialog">
  <ng-template #weightDialog>
    <button class="close" mat-button type="button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="addGroupWrap expand-dialog">
      <h2 matDialogTitle class="text-center">Manage Weightage of Comps</h2>
      <div mat-dialog-content class="pt-2">
        Comps list for
        <b
          >{{ cmaReportData?.subject?.UnparsedAddress }},{{ cmaReportData?.subject?.City }},
          {{ cmaReportData?.subject?.StateOrProvince }} {{ cmaReportData?.subject?.PostalCode }}</b
        >
      </div>
      <div>
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="table-wrapper">
              <table class="table table-bordered">
                <thead>
                  <tr>
                    <td>Comparables</td>
                    <td>Weightage</td>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let property of properties; let i = index">
                    <td class="comp-address address prop-itm text-left" *ngIf="i != 0">
                      <p class="mb-0">
                        {{ property.UnparsedAddress }} <br /><small>
                          {{ property.City }} , {{ property.StateOrProvince }} {{ property.PostalCode }}
                        </small>
                        <br />
                        <span class="adjusted-value">
                          Adjusted Price :
                          <span> ${{ property.adjustedPrice | number }} </span></span
                        >
                      </p>
                    </td>
                    <td *ngIf="i != 0">
                      <input
                        type="number"
                        class="form-control"
                        [(ngModel)]="property.percentage"
                        matSuffix="%"
                        (ngModelChange)="weightageChange(i)"
                        (wheel)="onWheel($event)"
                      />
                    </td>
                  </tr>
                  <tr class="footer-weightage">
                    <td>
                      <h6>Total Weightage</h6>
                      <div class="total-calc">
                        <span *ngFor="let property of properties; let i = index">
                          <span *ngIf="i != 0 && i != 1">+</span>
                          <span *ngIf="i != 0"
                            >(${{ property.adjustedPrice | number }} * {{ property.percentage }})</span
                          >
                        </span>
                        <strong>= ${{ properties[0]?.adjustedPrice | number }}</strong>
                      </div>
                    </td>
                    <td>
                      <h4 class="pt-2">{{ this.totalWeight }}%</h4>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <mat-dialog-actions>
        <div class="w-100 text-right">
          <button class="ml-1" type="submit" cdkFocusInitial mat-flat-button color="primary" (click)="saveAndProceed()">
            Submit
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </ng-template>
</div>

<div class="confirm-dialog">
  <ng-template #saveAdjustedValuesDialog>
    <button class="close" mat-button type="button" (click)="closeBackDialog()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="addGroupWrap expand-dialog">
      <h2 matDialogTitle class="text-center">Save Adjusted Values</h2>
      <div mat-dialog-content class="pt-2">Save adjusted Values? Unsaved ones will be lost!</div>
      <mat-dialog-actions>
        <div class="w-100 text-right">
          <button class="ml-1" type="submit" cdkFocusInitial mat-stroked-button color="primary" (click)="skipSaving()">
            Skip
          </button>
          <button
            class="ml-1"
            type="submit"
            cdkFocusInitial
            mat-flat-button
            color="primary"
            (click)="saveAdjustedValuesAndProceed()"
          >
            Save
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </ng-template>
</div>
